import React from 'react';

import Field from 'components/Field';
import FutureClassesVisibility from '../FutureClassesVisibility';
import PastClassesVisibility from '../PastClassesVisibility';
import ScheduledClassesVisibility from '../ScheduledClassesVisibility';

function ClassesVisibility() {
  return (
    <Field
      label="Select Class Visibility"
      labelClassName="m-b-s"
    >
      <div className="row">
        <PastClassesVisibility />
        <ScheduledClassesVisibility />
        <FutureClassesVisibility />
      </div>
    </Field>
  );
}

export default ClassesVisibility;
